/* Payment Widget Modals */
(function () {
  'use strict';

  function moveModalsToBody() {
    /* Move all payment widget modals to document.body so they sit above
       any stacking context created by product image containers */
    document.querySelectorAll('.payment-widget-modal').forEach(function (modal) {
      if (modal.parentNode !== document.body) {
        document.body.appendChild(modal);
      }
    });
  }

  function openModal(modalId) {
    var modal = document.getElementById(modalId);
    if (!modal) return;
    modal.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  function formatMoney(cents) {
    /* Use Shopify's money format or fallback to basic Rand formatting */
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '{{amount}}');
    }
    var amount = (cents / 100).toFixed(2);
    return 'R' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function updateWidgetAmounts(variant) {
    if (!variant || !variant.price) return;

    /* PayJustNow: divide by 3 */
    var pjnAmount = Math.ceil(variant.price / 3);
    document.querySelectorAll('[data-pjn-amount]').forEach(function (el) {
      el.textContent = formatMoney(pjnAmount);
    });

    /* Payflex: divide by 4 */
    var pfAmount = Math.ceil(variant.price / 4);
    document.querySelectorAll('[data-pf-amount]').forEach(function (el) {
      el.textContent = formatMoney(pfAmount);
    });
  }

  function init() {
    /* Move modals out of product grid stacking context */
    moveModalsToBody();

    /* Open triggers */
    document.querySelectorAll('[data-payment-widget-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openModal(this.getAttribute('data-payment-widget-open'));
      });
    });

    /* Close buttons */
    document.querySelectorAll('.payment-widget-modal__close').forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeModal(this.closest('.payment-widget-modal'));
      });
    });

    /* Backdrop click */
    document.querySelectorAll('.payment-widget-modal__backdrop').forEach(function (backdrop) {
      backdrop.addEventListener('click', function () {
        closeModal(this.closest('.payment-widget-modal'));
      });
    });

    /* Escape key */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var active = document.querySelector('.payment-widget-modal.is-active');
        if (active) closeModal(active);
      }
    });

    /* Listen for variant changes */
    document.addEventListener('product:variant-change', function (e) {
      if (e.detail && e.detail.variant) {
        updateWidgetAmounts(e.detail.variant);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init on Shopify section events (theme editor) */
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      moveModalsToBody();
      init();
    });
  }
})();
